import React from "react";
import moment from "moment";
import "moment/locale/pt-br";

import VisaoGeral from "../../../assets/images/svg-Overview.svg";

import { Container, Content } from "./styles";

function Dashboard() {
	moment.locale("pt-br");

	return (
		<Container>
			<Content>
				<div className='coming-soon'>
					<h1>Em Breve</h1>
					<p>Aguarde pelas proximas Atualizações</p>
					<img src={VisaoGeral} alt='Visão geral' />
				</div>
			</Content>
		</Container>
	);
}

export default Dashboard;
